import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { Profile } from '../builders/profile_builder';

export type ProfileModel = ITypedModel<Profile>;

angular.module('capability-ng-admin-authentication').factory('ngProfileModel', () => new Model(Profile));



// WEBPACK FOOTER //
// ./app/lib/authentication/models/profile_model.ts